import { render, staticRenderFns } from "./DataRuleForm.vue?vue&type=template&id=96d9b43c"
import script from "./DataRuleForm.vue?vue&type=script&lang=js"
export * from "./DataRuleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports